import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	type CONNECT_NUMBER_GQL_FIELD,
	ISSUE_FIELD_NUMBER_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { AggTransformerFunction } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggConnectNumberToLegacyField: AggTransformerFunction<
	typeof CONNECT_NUMBER_GQL_FIELD
> = (node) => ({
	...transformAggNodeToLegacyField(node),
	value: node.number ?? null,
	schema: {
		configuration: null,
		items: null,
		renderer: PLAIN_TEXT,
		system: null,
		custom: node.type,
		type: ISSUE_FIELD_NUMBER_CF_TYPE,
	},
});
